import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { BrowserRouter, Route, } from "react-router-dom";
import Home from "./page/home";


function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <Route exact path={'/'} component={Home} />
            </BrowserRouter>
        </div>
    );
}

export default App;
